<ng-template #tabContentTemplate>
  @if (activeTab() === 'language') {
    <div class="preferences-container languages">
      @for (language of languages(); track $index) {
        <button
          type="button" class="preference-item language d-flex flex-column align-items-start"
          [class.active]="language.code === selectedPreferences().language?.code"
          appOverlay type="tooltip" [content]="language.name" [placement]="'top'"
          [disableOpen]="languageNameEle?.scrollWidth == languageNameEle?.clientWidth"
          (click)="updatePreference('language', language)"
        >
          <div class="language-name" #languageNameEle>{{ language.name }}</div>
        </button>
      }
    </div>
  }

  @if (activeTab() === 'currency') {
    <div class="preferences-container currencies">
      @for (currency of currencies(); track $index) {
        <button
          type="button" class="preference-item currency d-flex flex-column align-items-start"
          appOverlay type="tooltip" [content]="currency.name" [placement]="'top'"
          [disableOpen]="currencyNameEle?.scrollWidth == currencyNameEle?.clientWidth"
          [class.active]="currency.code === selectedPreferences().currency?.code"
          (click)="updatePreference('currency', currency)"
        >
          <span class="currency-name" #currencyNameEle>{{ currency.name }}</span>
          <span class="currency-code-symbol">
            <span class="currency-code">{{ currency.code }}</span>
            <span class="currency-code-separator">&nbsp;-&nbsp;</span>
            <span class="currency-symbol">{{ currency.symbol }}</span>
          </span>
        </button>
      }
    </div>
  }
</ng-template>

<div class="preferences-content">
  <app-nav-tabs
    class="tabs-container"
    [tabs]="tabs()"
    [activeTab]="activeTab()"
    (activeTabChange)="onTabChange($event)"
  />

  <div class="tab-content">
    <ng-container
      [ngTemplateOutlet]="tabContentTemplate"
    />
  </div>

  <app-button-group
    class="actions-container"
    [options]="actions"
    (onClickEvent)="handleActionClick($event)"
  />
</div>
